import { administratorRoles } from "../config/roles";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/ticket-hospitality-product";

/**
 * The ticket hospitality products list. Paged by the search endpoint and read on
 * arrival. The ticketing feed creates and removes these, so there is no add or delete.
 */
export const ticketHospitalityProductsListDefinition: ListDefinition = {
  path: "/ticket-hospitality-products",
  entityName: "dwtickethospitalityproduct",
  recordRoute,
  title: "Ticket Hospitality Products",
  allowedRoles: administratorRoles,
  data: "search-paged",
  searchOnLoad: true,
  filters: [
    { name: "producttype", label: "Product Type", kind: "text" },
    { name: "source", label: "Source", kind: "text" },
  ],
  filterByStatus: false,
  allowAdd: false,
  allowStatusEdit: false,
  allowDelete: false,
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 300,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    { key: "source", label: "Source", width: 200, sortable: true },
    {
      key: "averageprice",
      label: "Average Price",
      width: 200,
      display: "money",
      sortable: true,
    },
    { key: "ticketcount", label: "Ticket Count", width: 200, sortable: true },
    {
      key: "ishospitality",
      label: "Is Hospitality",
      width: 200,
      display: "yesno-badge",
      sortable: true,
    },
  ],
};
